import React from "react";
import { Link } from "react-router-dom";

export const Footer: React.FC = () => {
  return (
    <footer id="rodape">
      <div>
        {/* LOGO */}
        <h5 className="logo">
          <Link to="/" title="Rabo de Galo Editora">
            Rabo de Galo Editora
          </Link>
        </h5>

        <div className="copyrights">
          <p>Rabo de Galo Editora © 2025 - Todos os direitos reservados.</p>
          <p>Curitiba/PR - Brasil</p>
        </div>
      </div>
    </footer>
  );
};
